<template>
<div class="box-container">
    <div class="text-center">
        <p class="black-box-title">
            Recent Cultural Display
        </p>
        <p>
            See what others are exploring
        </p>
    </div>
    <div id="img-contain" v-if="products.length > 0">
        <div @click="openUrl(products[0].permalink)" class="item item-event" v-bind:style="{ backgroundImage : 'url(' + (products[0].image.src) + ')' }">
            <div class="event-overlay">
                <div class="text-uppercase font18 font-weight-600">{{products[0].category}}</div>
                <div>
                    <b-icon icon="geo" class="culture-primary"></b-icon><span class="culture-primary">Sold on </span> {{products[0].shop_name }}
                </div>
            </div>
        </div>
        <section class="equal-pad" >
            <div @click="openUrl(products[1].permalink)" class="item item-food" v-bind:style="{ backgroundImage : 'url(' + (products[1].image.src) + ')' }">
                <div class="_overlay">
                    <div class="text-uppercase font18 f-14 font-weight-600">{{products[1].category_name }}</div>
                    <div class="font12 font8">
                        <b-icon icon="geo" class="culture-primary"></b-icon><span class="culture-primary">Sold on </span> {{products[1].shop_name }}
                    </div>
                </div>
            </div>
            <div @click="openUrl(products[2].permalink)" class="item item-fashion" v-bind:style="{ backgroundImage : 'url(' + (products[2].image.src) + ')' }">
                <div class="_overlay">
                    <div class="text-uppercase font18 f-14 font-weight-600">{{products[2].category_name }}</div>
                    <div class="font12 font8">
                        <b-icon icon="geo" class="culture-primary"></b-icon><span class="culture-primary">Sold on </span>{{products[2].shop_name }}
                    </div>
                </div>
            </div>
            <div @click="openUrl(products[3].permalink)" class="item item-art" v-bind:style="{ backgroundImage : 'url(' + (products[3].image.src) + ')' }">
                <div class="_overlay">
                    <div class="text-uppercase font18 f-14 font-weight-600">{{products[3].category_name }}</div>
                    <div class="font12 font8">
                        <b-icon icon="geo" class="culture-primary"></b-icon><span class="culture-primary">Sold on </span> {{products[3].shop_name }}
                    </div>
                </div>
            </div>
            <div @click="openUrl(products[4].permalink)" class="item item-fest" v-bind:style="{ backgroundImage : 'url(' + (products[4].image.src) + ')' }">
                <div class="_overlay">
                    <div class="text-uppercase font18 f-14 font-weight-600">{{products[4].category_name }}</div>
                    <div class="font12 font8">
                        <b-icon icon="geo" class="culture-primary"></b-icon><span class="culture-primary">Sold on </span> {{products[4].shop_name }}
                    </div>
                </div>
            </div>

        </section>
    </div>
</div>
</template>

<script>
export default {
    name: "black-box",
    props: ['products'],
    methods: {
        openUrl(url) {
            window.open(url, "_blank")
        }
    }
}
</script>

<style lang="scss" scoped>
.box-container {
    height: 856px;
    background: #000;
    color: #fff;

    @media screen and (min-device-width: 760px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
        height: 770px;
    }
    @media screen and (min-device-width: 712px) and (max-device-width: 1200px) and (-webkit-min-device-pixel-ratio: 1) {
        height: 700px;
    }
}

.equal-pad {
    padding: 50px;

    @media screen and (min-device-width: 760px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {

        padding: 25px
    }
    @media screen and (min-device-width: 712px) and (max-device-width: 1138px) and (-webkit-min-device-pixel-ratio: 1) {
        padding: 9px
    }
}

.first-col-img {
    border-radius: 10px;
    height: 400px;
}

.side {
    display: flex;
    flex-direction: column;
}

.row {
    margin: 0 !important
}

.black-box-title {
    font-weight: 600;
    padding-top: 96px;
    font-size: 32px;
    line-height: 64px;
    letter-spacing: -0.25px;
    text-transform: uppercase;
}

#img-contain {
    display: flex;
    padding: 0 4rem;
    justify-content: center;
    margin-top: 90px;

    @media screen and (min-device-width: 760px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {

        padding: 0 1.5rem;
    }
     @media screen and (min-device-width: 712px) and (max-device-width: 1138px) and (-webkit-min-device-pixel-ratio: 1) {

        padding: 0 1.2rem;
    }
}

#img-contain>div {
    flex: 0 0 49%;
    /* width of first flex item in main container */
    height: 470px;

    @media screen and (min-device-width: 760px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
        height: 350px;
    }
    @media screen and (min-device-width: 712px) and (max-device-width: 1200px) and (-webkit-min-device-pixel-ratio: 1) {
        height: calc(20em + 5px);
    }
}

section {
    flex: 0 0 49%;
    /* width of second flex item in main container */
    display: flex;
    /* nested flex container to arrange smaller items */
    flex-wrap: wrap;
    /* make container multi-line */
}

section>.item {
    flex: 0 0 43%;
    height: 168px;

    @media screen and (min-device-width: 760px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {

        height: 130px;

    }
     @media screen and (min-device-width: 712px) and (max-device-width: 1200px) and (-webkit-min-device-pixel-ratio: 1) {

        height: 130px;

    }
}

.item {
    margin: 15px;
    border-radius: 10px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    cursor: pointer;

    @media screen and (max-device-width: 320px) and (-webkit-min-device-pixel-ratio: 1) {
        margin: 13px;
    }

    @media screen and (min-device-width: 760px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
        margin: 5px;

    }
     @media screen and (min-device-width: 712px) and (max-device-width: 1138px) and (-webkit-min-device-pixel-ratio: 1) {
        margin: 5px;

    }

    @media screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 1) {

        margin: 10px;

    }
}

.item-food {
    transition: all 1s ease-in-out;
}

.item-event {
    background-image: url('../assets/images/woman.jpeg');
}

.item-fashion {
    transition: all 1s ease-in-out;
}

.item-fest {
    transition: all 1s ease-in-out;
}

.item-art {
    transition: all 1s ease-in-out;
}

.item-event .event-overlay {
    background: rgba(0, 0, 0, 0.8);
    margin-top: 360px;
    position: absolute;
    height: 118px;
    width: 100%;
    overflow: hidden;
    padding: 30px;
    transition: all 1s ease-in-out;

    @media screen and (min-device-width: 760px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {

        margin-top: 260px;
    }
    @media screen and (min-device-width: 712px) and (max-device-width: 1138px) and (-webkit-min-device-pixel-ratio: 1) {

        margin-top: 230px;
    }
     
}

.item-event:hover>.event-overlay {
    height: 100%;
    margin-top: 0;
}

.item-food ._overlay,
.item-fashion ._overlay,
.item-fest ._overlay,
.item-art ._overlay {
    background: rgba(0, 0, 0, 0.8);
    height: 94px;
    overflow: hidden;
    padding: 20px;
    margin: 65px 10px 10px 10px;
    transition: all 1s ease-in-out;
    border-radius: 8px;

    @media screen and (min-device-width: 712px) and (max-device-width: 1138px) and (-webkit-min-device-pixel-ratio: 1) {

        margin: 30px 10px 10px 10px;
    }
}

.item-food:hover,
.item-fashion:hover,
.item-fest:hover,
.item-art:hover {
    transform: scale(1.2);
}

.item-food:hover>._overlay,
.item-fashion:hover>._overlay,
.item-fest:hover>._overlay,
.item-art:hover>._overlay {
    height: 89%;
    margin-top: 8px;
}
</style>
